<template>
  <v-container fluid>
    <v-card>
      <v-card-title> Resultado Consulta Motor </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="2"> ID Consulta Motor </v-col>
          <v-col>
            <span class="body-2">{{ ConsultaMotorId }}</span>
            <v-btn icon @click="loadConsultaMotor">
              <v-icon>refresh</v-icon></v-btn
            >
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              dense
              :headers="headers"
              :items="model.grupo0"
              :loading="loading"
              class="elevation-1"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-xs-left caption">{{ item.descripcion }}</td>
                  <td class="text-xs-left caption">{{ item.valor }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="5" v-if="model.grupo1.length > 0">
            <v-data-table
              dense
              :headers="headers"
              :items="model.grupo1"
              :items-per-page="25"
              :loading="loading"
              class="elevation-1"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-xs-left caption">{{ item.descripcion }}</td>
                  <td class="text-xs-left caption">{{ item.valor }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>

          <v-col>
            <v-row>
              <v-col cols="12" v-if="model.grupo2.length > 0">
                <h3>Antecedentes BCRA</h3>
                <v-data-table
                  dense
                  :headers="headersBcra"
                  :items="model.antecedentesBcra"
                  :items-per-page="15"
                  :loading="loading"
                  class="elevation-1"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-xs-left caption">{{ item.origen }}</td>
                      <td class="text-xs-left caption">{{ item.entidad }}</td>
                      <td class="text-xs-right caption">
                        {{ item.monto | currency }}
                      </td>
                      <td class="text-xs-left caption">{{ item.situacion }}</td>
                      <td class="text-xs-left caption">{{ item.periodo }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row>
              <h3>Variables Smarter</h3>
              <v-col cols="12" v-if="model.grupo3.length > 0">
                <v-data-table
                  dense
                  :headers="headers"
                  :items="model.grupo3"
                  :items-per-page="15"
                  :loading="loading"
                  class="elevation-1"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-xs-left caption">
                        {{ item.descripcion }}
                      </td>
                      <td class="text-xs-left caption">{{ item.valor }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col v-if="model.grupo4.length > 0">
            <v-data-table
              dense
              :headers="headers"
              :items="model.grupo4"
              :items-per-page="15"
              :loading="loading"
              class="elevation-1"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-xs-left caption">{{ item.descripcion }}</td>
                  <td class="text-xs-left caption">{{ item.valor }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-row> </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';

import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      model: {
        grupo0: [],
        grupo1: [],
        grupo2: [],
        grupo3: [],
        grupo4: [],
        grupo5: [],
      },
      headers: [
        // definición de columnas
        { text: 'Variable', value: 'descripcion' },
        { text: 'Valor', value: 'valor' },
      ],
      headersBcra: [
        // definición de columnas
        { text: 'Origen', value: 'origen' },
        { text: 'Entidad', value: 'entidad' },
        { text: 'Monto', value: 'monto' },
        { text: 'Situación', value: 'situacion' },
      ],
    };
  },
  props: {
    ConsultaMotorId: {
      type: Number,
    },
  },
  watch: {
    ConsultaMotorId: function () {
      if (this.ConsultaMotorId) this.loadConsultaMotor();
    },
  },
  created: function () {
    this.loadConsultaMotor();
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    async loadConsultaMotor() {
      this.loading = true;
      try {
        var result = await http.get(
          'consultasmotorsiisa' + '?ejecucionId=' + this.ConsultaMotorId
        );

        this.model = result;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
